import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stickyHeader', pure: true, standalone: true })
export class StickyHeaderPipe implements PipeTransform {
  public transform(value: string, location: string, scrollY: number, prelogin?: boolean): string {
    // This pipe is currently only used for MTLS as the nav is transparent

    const fullHeightPreloginLocations =
      location.includes('/homepage') ||
      location.includes('/product/benefits') ||
      location.includes('/product/inspiration');

    const otherPreloginLocations =
      prelogin && (location.includes('/details') || location.includes('/publication') || location.includes('/article'));

    if (value !== 'modern') {
      return '';
    }

    if (prelogin && fullHeightPreloginLocations && !otherPreloginLocations) {
      // True for prelogin homepage, benefits and inspiration page
      return this.handleContentOutsideLogin(scrollY);
    }

    return this.handleHeaderClass(location, scrollY, otherPreloginLocations);
  }

  private handleContentOutsideLogin(scrollY: number): string {
    if (scrollY > 0) {
      return 'sticky-header-transparent';
    } else {
      return 'fixed-header-transparent';
    }
  }

  private handleHeaderClass(location: string, scrollY: number, otherPreloginLocations: boolean): string {
    const element = document.getElementsByClassName('product-landing-top-section')[0];
    const navElement = document.getElementsByClassName('main-container')[0];

    if (otherPreloginLocations) {
      // only true for the new prelogin Feature when prelogin switches are ON
      return 'main-container-modern';
    }

    if (location.includes('/homepage')) {
      if (element && navElement && scrollY > element?.clientHeight) {
        return 'sticky-header-transparent';
      }

      return 'fixed-header-transparent';
    }

    return 'fixed-header';
  }
}
